<template>
    <div id="app">
        <!--Load in modals here-->
        <add-category />
        <edit-category />
        <change-category />
        <add-product />
        <add-brand />
        <edit-product />
        <show-product />
        <add-customer />
        <add-order-item />
        <no-customer-yet />
        <show-category-info />
        <add-job />
        <edit-job />

        <notifications group="success" position="top center" :duration="5000" :width="500">
            <template slot="body" slot-scope="props">
                <div class="custom-template-success">
                    <div class="custom-template-icon-success">
                        <i class="glyphicon glyphicon-check"></i>
                    </div>
                    <div class="custom-template-content">
                        <div class="custom-template-title">
                            {{props.item.title}}
                        </div>
                        <div class="custom-template-text"
                             v-html="props.item.text"></div>
                    </div>
                    <div class="custom-template-close"
                         @click="props.close">
                        <i class="glyphicon glyphicon-remove"></i>
                    </div>
                </div>
            </template>
        </notifications>

        <notifications group="danger" position="top center" :duration="5000" :width="500">
            <template slot="body" slot-scope="props">
                <div class="custom-template-danger">
                    <div class="custom-template-icon-danger">
                        <i class="glyphicon glyphicon-exclamation-sign"></i>
                    </div>
                    <div class="custom-template-content">
                        <div class="custom-template-title">
                            {{props.item.title}}
                        </div>
                        <div class="custom-template-text"
                             v-html="props.item.text"></div>
                    </div>
                    <div class="custom-template-close"
                         @click="props.close">
                        <i class="glyphicon glyphicon-remove"></i>
                    </div>
                </div>
            </template>
        </notifications>

        <bt-header :active="activeScreen" />
        <router-view :key="$route.fullPath" />

    </div>
</template>

<script>
    import AddCategory from './components/modals/AddCategory'
    import AddProduct from './components/modals/AddProduct'
    import AddCustomer from './components/modals/AddCustomer'
    import EditProduct from './components/modals/EditProduct'
    import ShowProduct from './components/modals/ShowProduct'
    import AddOrderItem from './components/modals/AddOrderItem'
    import NoCustomerYet from './components/modals/NoCustomerYet'
    import AddBrand from './components/modals/AddBrand'
    import EditCategory from './components/modals/EditCategory'
    import ChangeCategory from './components/modals/ChangeCategory'
    import BtHeader from './components/BTHeader.vue'
    import ShowCategoryInfo from './components/modals/ShowCategoryInfo'
    import { mapGetters } from 'vuex'
    import AddJob from './components/modals/AddJob'
    import EditJob from './components/modals/EditJob'

    export default {
        name: 'app',
        components: {
            ShowCategoryInfo,
            ChangeCategory,
            BtHeader,
            EditCategory,
            AddBrand,
            NoCustomerYet,
            AddOrderItem,
            ShowProduct,
            EditProduct,
            AddCustomer,
            AddProduct,
            AddCategory,
            AddJob,
            EditJob
        },
        computed: {
            ...mapGetters({
                activeScreen: 'activeScreen'
            })
        }
    }
</script>

<style>

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        min-width: 1280px;
    }

    body {
        background-color: #c1c1c1;
        overflow-x: hidden;
    }

    .btn-danger {
        background-color: #52b2da;
        border-color: #0086be;
    }

        .btn-danger.focus, .btn-danger:focus, .btn-danger:hover, .btn-danger:active, .btn-danger.active, .btn-danger.active:focus, .btn-danger.active:hover {
            background-color: #0086be;
            border-color: #0086be;
        }

    .bt-header {
        height: 180px;
    }

    .bt-navbar {
        z-index: 1;
        padding-top: 4px;
        font-size: 16px;
        font-weight: 500;
        color: white;
        height: 30px;
        background-color: #0086be;
        -webkit-box-shadow: 0px 5px 8px -1px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: 0px 5px 8px -1px rgba(0, 0, 0, 0.75);
        box-shadow: 0px 5px 8px -1px rgba(0, 0, 0, 0.75);
    }

    .bt-navbar-item {
        cursor: pointer;
        padding-left: 20px;
        padding-right: 20px;
        border-right: 1px solid;
    }

        .bt-navbar-item:hover:not(.bt-navbar-item-active) {
            color: black;
            border-color: white;
        }

    .bt-navbar-item-active {
        color: lightgray;
        border-color: white;
    }

    .bt-navbar-languages {
        background-color: white;
        height: 20px;
        padding-bottom: 25px;
    }

    .bt-navbar-content {
        background-color: white;
        padding: 5px;
    }

    .content {
        background-color: #fff;
        padding: 35px 5px 210px;
        min-height: calc(100vh - 225px);
        overflow: hidden;
    }

    .bt-footer {
        width: 100%;
        min-width: 1280px;
        height: auto;
        margin-top: -175px !important;
        background: #333333;
        padding-bottom: 5px;
        opacity: 0.9;
    }

    .bt-footer-content {
        color: white;
        padding-top: 5px;
        min-height: 190px;
    }

    .logo {
        position: relative;
        width: 336px;
        height: 58px;
        padding-right: 30px;
    }

    .action-image {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
        transition: 0.3s;
        max-width: 100%;
    }

    .facebook {
        text-decoration-line: none !important;
    }

    .instagram {
        text-decoration-line: none !important;
    }

    .language {
        padding-left: 5px;
        padding-right: 5px;
        cursor: pointer;
    }

    .opacitated {
        opacity: 0.4;
    }

    .panel-heading {
        border-bottom: 1px solid lightgrey;
    }

    @media screen and (max-width: 736px) {
        .logo {
            position: relative;
            width: 336px;
            height: 58px;
        }

        .facebook {
            display: none;
        }

        .linked-in {
            display: none;
        }

        .instagram {
            display: none;
        }
    }

    @media screen and (max-width: 1050px) {
        body {
            overflow-x: auto;
        }
    }

    .custom-template-success {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        text-align: left;
        font-size: 13px;
        margin: 5px;
        margin-top: 20px;
        margin-bottom: 0;
        align-items: center;
        justify-content: center;
        background: #E8F9F0;
        border: 2px solid #D0F2E1;
    }

    .custom-template-icon-success {
        flex: 0 1 auto;
        color: #15C371;
        font-size: 20px;
        padding: 0 10px;
    }

    .custom-template-danger {
        display: flex;
        color: white;
        flex-direction: row;
        flex-wrap: nowrap;
        text-align: left;
        font-size: 13px;
        margin: 5px;
        margin-top: 20px;
        margin-bottom: 0;
        align-items: center;
        justify-content: center;
        background: #E54D42;
        border: 2px solid #b6302a;
    }

    .custom-template-icon-danger {
        flex: 0 1 auto;
        color: #b6302a;
        font-size: 20px;
        padding: 0 10px;
    }

    .custom-template-close {
        flex: 0 1 auto;
        padding: 0 20px;
        font-size: 16px;
        opacity: 0.2;
        cursor: pointer;
    }

        .custom-template-close:hover {
            opacity: 0.8;
        }

    .custom-template-content {
        padding: 10px;
        flex: 1 0 auto;
    }

    .custom-template-title {
        letter-spacing: 1px;
        text-transform: uppercase;
        font-size: 10px;
        font-weight: 600;
    }

    .mb-20 {
        margin-bottom: 20px;
    }

    .align-middle {
        vertical-align: middle !important;
    }

    .vue-lightbox ul li img {
        width: 110% !important;
    }

    .lightbox-overlay {
        z-index: 5;
        background: rgba(255,255,255,.7) !important;
    }

        .lightbox-overlay .holder img {
            width: fit-content !important;
            display: inline-block !important;
            margin-bottom: 40px !important;
        }

        .lightbox-overlay .holder .nav .close span {
            color: black !important;
        }

    .vue-lightbox ul li {
        background: none !important;
        margin: 0 !important;
        padding: 0 !important;
    }

        .vue-lightbox ul li:hover {
            cursor: pointer;
            transform: scale(1.05);
            transition: all .2s ease-in-out;
        }

    .card img:hover {
        transform: scale(1.05);
        transition: all .2s ease-in-out;
    }

    .tooltip {
        display: block !important;
        z-index: 10000;
    }

        .tooltip .tooltip-inner {
            background: black;
            color: white;
            border-radius: 16px;
            padding: 5px 10px 4px;
        }

        .tooltip .tooltip-arrow {
            width: 0;
            height: 0;
            border-style: solid;
            position: absolute;
            margin: 5px;
            border-color: black;
            z-index: 1;
        }

        .tooltip[x-placement^="top"] {
            margin-bottom: 5px;
        }

            .tooltip[x-placement^="top"] .tooltip-arrow {
                border-width: 5px 5px 0 5px;
                border-left-color: transparent !important;
                border-right-color: transparent !important;
                border-bottom-color: transparent !important;
                bottom: -5px;
                left: calc(50% - 5px);
                margin-top: 0;
                margin-bottom: 0;
            }

        .tooltip[x-placement^="bottom"] {
            margin-top: 5px;
        }

            .tooltip[x-placement^="bottom"] .tooltip-arrow {
                border-width: 0 5px 5px 5px;
                border-left-color: transparent !important;
                border-right-color: transparent !important;
                border-top-color: transparent !important;
                top: -5px;
                left: calc(50% - 5px);
                margin-top: 0;
                margin-bottom: 0;
            }

        .tooltip[x-placement^="right"] {
            margin-left: 5px;
        }

            .tooltip[x-placement^="right"] .tooltip-arrow {
                border-width: 5px 5px 5px 0;
                border-left-color: transparent !important;
                border-top-color: transparent !important;
                border-bottom-color: transparent !important;
                left: -5px;
                top: calc(50% - 5px);
                margin-left: 0;
                margin-right: 0;
            }

        .tooltip[x-placement^="left"] {
            margin-right: 5px;
        }

            .tooltip[x-placement^="left"] .tooltip-arrow {
                border-width: 5px 0 5px 5px;
                border-top-color: transparent !important;
                border-right-color: transparent !important;
                border-bottom-color: transparent !important;
                right: -5px;
                top: calc(50% - 5px);
                margin-left: 0;
                margin-right: 0;
            }

        .tooltip.popover .popover-inner {
            background: #f9f9f9;
            color: black;
            padding: 24px;
            border-radius: 5px;
            box-shadow: 0 5px 30px rgba(black, .1);
        }

        .tooltip.popover .popover-arrow {
            border-color: #f9f9f9;
        }

        .tooltip[aria-hidden='true'] {
            visibility: hidden;
            opacity: 0;
            transition: opacity .15s, visibility .15s;
        }

        .tooltip[aria-hidden='false'] {
            visibility: visible;
            opacity: 1;
            transition: opacity .15s;
        }
</style>
